import { FC } from 'react';

import { TextFieldType } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

import Searchbar from '@/components/Searchbar/Searchbar';

export interface FilterSearchBarProps {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<TextFieldType>) => void;
  onClear: () => void;
  className?: string;
}

const FilterSearchBar: FC<FilterSearchBarProps> = ({
  onChange,
  onClear,
  placeholder,
  value,
  className,
}) => (
  <div className={cn('w-full text-left', className)}>
    <Searchbar
      data-testid="desktop-searchbar"
      showSearchTitle
      className={'hidden w-full flex-col md:flex'}
      onChange={onChange}
      onClear={onClear}
      placeholder={placeholder}
      searchValue={value}
    />
    <Searchbar
      data-testid="mobile-searchbar"
      elevation={1}
      className={'b-0 flex w-full md:hidden [&>form]:w-full'}
      onChange={onChange}
      onClear={onClear}
      placeholder={placeholder}
      searchValue={value}
    />
  </div>
);

export default FilterSearchBar;
